// extracted by mini-css-extract-plugin
export default {"uploadWrapper":"fileUpload_uploadWrapper__xRxvD","xlWrapper":"fileUpload_xlWrapper__AAuTp","notificationPlacement":"fileUpload_notificationPlacement__2fHez"};